export function extractPhoneNumber(phoneString: string): { href: string; formatted: string } {
    const cleanedNumber = phoneString.replace(/\D/g, '');

    const formattedNumber = cleanedNumber.replace(/(\d{2})(?=\d)/g, '$1 ');

    return {
        href: `tel:${cleanedNumber}`,
        formatted: formattedNumber.trim(),
    };
}
